import { lazyRouteComponent } from '@tanstack/react-router';

export const privacyPageLoadable = lazyRouteComponent(() =>
  import('../../ui/privacy-page').then((m) => ({
    default: m.PrivacyPage,
  })),
);
